module.exports = __webpack_public_path__ + "img/clip_image090.9aa722f0.png";